<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <app-uzemszunet-sav forras="ugyfelkapu"></app-uzemszunet-sav>
  <div class="naplo-eszkozsor">
    <ion-button style="--background:var(--naplo)" (click)="szinkron()"><ion-icon slot="start" name="sync"></ion-icon> Tárhely szinkron</ion-button>
    <ion-button fill="outline" (click)="hozzarNyit()"><ion-icon slot="start" name="link"></ion-icon> Fiók hozzárendelése</ion-button>
    <ion-button fill="outline" color="medium" (click)="fiokokNyit()"><ion-icon slot="start" name="key"></ion-icon> Fiókok ({{ fiokok.length }})</ion-button>
    <ion-searchbar style="flex:1; min-width:200px" placeholder="Feladó / tárgy / típus" [(ngModel)]="szuro"></ion-searchbar>
  </div>

  <!-- Hozzárendelt fiókok az ügyfélhez -->
  <div *ngIf="hozzarendelesek.length" class="naplo-eszkozsor" style="gap:6px; padding-top:0">
    <ion-chip *ngFor="let h of hozzarendelesek" outline color="primary">
      <ion-icon [name]="h.tipus === 'cegkapu' ? 'business' : 'person'"></ion-icon>
      <ion-label>{{ h.fiok_cimke || h.fiok_login }}<span *ngIf="h.mailbox_nev"> · {{ h.mailbox_nev }}</span><span *ngIf="h.szuro"> · szűrő: {{ h.szuro }}</span></ion-label>
      <ion-icon name="close-circle" (click)="torolHozzar(h)"></ion-icon>
    </ion-chip>
  </div>

  <div *ngIf="!hozzarendelesek.length" class="ures" style="padding:24px">
    <ion-icon name="link-outline"></ion-icon>
    Ehhez az ügyfélhez még nincs hozzárendelt tárhely-fiók. Vegyél fel egy fiókot (login + jelszó + TOTP), majd
    <b>rendeld hozzá</b> – a postafiók nevével (pl. adószám) választhatod ki, melyik tárhelyet olvassa.
  </div>

  <div *ngIf="hozzarendelesek.length && !uzenetek.length" class="ures">
    <ion-icon name="mail-outline"></ion-icon>
    Még nincs letöltött üzenet. Nyomd meg a <b>Tárhely szinkron</b> gombot.
  </div>

  <div class="tabla-wrap" *ngIf="uzenetek.length">
    <table class="naplo-tabla tarhely-tabla">
      <thead><tr><th></th><th>Érkezett</th><th>Feladó</th><th class="targy-oszlop">Tárgy</th><th>Típus</th><th>Forrás</th><th>Áll.</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let u of szurtUzenetek" class="kattinthato" [style.background]="u.allapot === 'uj' ? '#fffbeb' : null" (click)="megnyitUzenet(u)">
          <td><ion-icon [name]="u.irany === 'kimeno' ? 'arrow-up-circle' : 'arrow-down-circle'" [style.color]="u.irany === 'kimeno' ? '#64748b' : 'var(--naplo)'"></ion-icon></td>
          <td style="white-space:nowrap">{{ u.erkezett }}</td>
          <td>{{ u.felado }}</td>
          <td class="targy-oszlop"><b *ngIf="u.allapot==='uj'">{{ u.targy }}</b><span *ngIf="u.allapot!=='uj'">{{ u.targy }}</span></td>
          <td>{{ u.tipus }}</td>
          <td>{{ u.fiok_cimke }}</td>
          <td><ion-badge [color]="u.allapot === 'uj' ? 'warning' : 'medium'">{{ u.allapot === 'uj' ? 'Új' : 'Olv.' }}</ion-badge></td>
          <td style="white-space:nowrap" (click)="$event.stopPropagation()">
            <ion-button size="small" fill="clear" color="success" (click)="letoltMelleklet(u)" title="Melléklet letöltése"><ion-icon slot="icon-only" name="download"></ion-icon></ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- Globális fiókok kezelése -->
<ion-modal #fiokokModal cssClass="naplo-wide-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>Tárhely-fiókok (intézmény)</ion-title>
      <ion-buttons slot="end"><ion-button (click)="fiokokModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding">
      <p style="font-size:.85rem; color:#475569">
        Itt egyszer felviszed a hitelesítő adatokat (login + jelszó + TOTP secret). Egy fiók <b>több ügyfélhez</b> is
        hozzárendelhető, és egy login <b>több postafiókot</b> is láthat (cégkapu + ügyfélkapu+ egyszerre).
      </p>
      <ion-button style="--background:var(--naplo)" (click)="ujFiok()"><ion-icon slot="start" name="add"></ion-icon> Új fiók</ion-button>
      <ion-list>
        <ion-item *ngFor="let f of fiokok">
          <ion-icon slot="start" name="key" color="primary"></ion-icon>
          <ion-label>
            <h3>{{ f.cimke || f.login }}</h3>
            <p>{{ f.login }} <span *ngIf="f.van_totp">· TOTP ✔</span> <span *ngIf="!f.aktiv">· inaktív</span> · {{ f.hozzarendeles_db }} ügyfélhez</p>
            <p *ngIf="f.utolso_szinkron">Utolsó szinkron: {{ f.utolso_szinkron }}</p>
          </ion-label>
          <ion-button slot="end" fill="clear" (click)="szerkFiok(f)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
          <ion-button slot="end" fill="clear" color="danger" (click)="torolFiok(f)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button>
        </ion-item>
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Fiók szerkesztő -->
<ion-modal #fiokModal class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>{{ szerk?.id ? 'Fiók módosítása' : 'Új fiók' }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="fiokModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-item><ion-label position="stacked">Címke (megjelenő név)</ion-label><ion-input [(ngModel)]="szerk.cimke" placeholder="pl. Saját Ügyfélkapu+"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Login (felhasználónév) *</ion-label><ion-input [(ngModel)]="szerk.login" autocapitalize="off"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Jelszó {{ szerk.van_jelszo ? '(beállítva – üresen marad)' : '' }}</ion-label><ion-input type="password" [(ngModel)]="szerk.jelszo" placeholder="••••••"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">TOTP secret (2FA) {{ szerk.van_totp ? '(beállítva)' : '' }}</ion-label><ion-input [(ngModel)]="szerk.totp_secret" placeholder="pl. JBSWY3DPEHPK3PXP" autocapitalize="off"></ion-input></ion-item>
      <ion-item><ion-checkbox slot="start" [(ngModel)]="szerk.aktiv"></ion-checkbox><ion-label>Aktív</ion-label></ion-item>
      <ion-note color="medium" style="display:block; padding:10px 4px; font-size:.78rem">
        A jelszó és a TOTP secret titkosítva tárolódik. A TOTP secret a 2 lépcsős hitelesítés megosztott kulcsa
        (az authenticator-appal megosztott alfanumerikus kód), nem az aktuális 6 jegyű szám.
      </ion-note>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" (click)="mentFiok()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Hozzárendelés az ügyfélhez -->
<ion-modal #hozzarModal class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>Fiók hozzárendelése – {{ aktiv.ugyfelNev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="hozzarModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="ujHozzar">
      <ion-item><ion-label position="stacked">Fiók *</ion-label>
        <ion-select [(ngModel)]="ujHozzar.fiok_id" interface="popover" (ionChange)="mailboxBetolt(false)">
          <ion-select-option *ngFor="let f of fiokok" [value]="f.id">{{ f.login }}{{ f.cimke && f.cimke !== f.login ? ' · ' + f.cimke : '' }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item><ion-label position="stacked">Tárhely típusa</ion-label>
        <ion-select [(ngModel)]="ujHozzar.tipus" interface="popover">
          <ion-select-option *ngFor="let t of tipusOpciok" [value]="t.value">{{ t.label }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item>
        <ion-label position="stacked">Postafiók</ion-label>
        <ion-select [(ngModel)]="ujHozzar.mailbox_nev" interface="popover" placeholder="válassz">
          <ion-select-option value="">Összes postafiók</ion-select-option>
          <ion-select-option *ngFor="let m of mailboxLista" [value]="m.mailboxName">{{ m.mailboxName }}</ion-select-option>
        </ion-select>
        <ion-button slot="end" fill="clear" size="small" (click)="mailboxBetolt(true)" [disabled]="mailboxLoading" title="Postafiókok frissítése (belépés)">
          <ion-spinner *ngIf="mailboxLoading" name="dots"></ion-spinner><ion-icon *ngIf="!mailboxLoading" slot="icon-only" name="refresh"></ion-icon>
        </ion-button>
      </ion-item>
      <ion-item *ngIf="!mailboxLista.length">
        <ion-label position="stacked">Postafiók neve (kézzel)</ion-label>
        <ion-input [(ngModel)]="ujHozzar.mailbox_nev" placeholder="pl. adószám vagy „értesítési tárhely”"></ion-input>
      </ion-item>
      <ion-item><ion-label position="stacked">Szűrő (opcionális) – értesítési tárhelynél ügyfélre szűr</ion-label>
        <ion-input [(ngModel)]="ujHozzar.szuro" placeholder="pl. ügyfél neve vagy adószáma"></ion-input></ion-item>
      <ion-note color="medium" style="display:block; padding:10px 4px; font-size:.78rem">
        Egy belépés több postafiókot is lát (a <ion-icon name="refresh"></ion-icon> frissít belépéssel). Cégkapunál válaszd a cég adószámú
        postafiókját. Az <b>értesítési tárhely</b> sok ügyfél üzenetét tartalmazza – ott a <b>szűrővel</b> (ügyfél neve/adószáma) szűrhetsz.
      </ion-note>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" (click)="mentHozzar()">Hozzárendelés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<!-- Üzenet részletei -->
<ion-modal #uzenetModal class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff">
      <ion-title>Üzenet részletei</ion-title>
      <ion-buttons slot="end"><ion-button (click)="uzenetModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="uzenetReszlet">
      <h2 style="color:#134e4a; margin-top:0">{{ uzenetReszlet.targy }}</h2>
      <table class="naplo-tabla" style="margin-top:8px">
        <tbody>
          <tr *ngFor="let r of metaSorok()"><td style="font-weight:600; width:40%">{{ r.kulcs }}</td><td>{{ r.ertek }}</td></tr>
        </tbody>
      </table>
      <ion-button expand="block" class="ion-margin-top" color="success" (click)="letoltMelleklet(uzenetReszlet)">
        <ion-icon slot="start" name="download"></ion-icon> Melléklet letöltése
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
